import { render, staticRenderFns } from "./noAuth.vue?vue&type=template&id=6c1f40a6&scoped=true"
import script from "./noAuth.vue?vue&type=script&lang=js"
export * from "./noAuth.vue?vue&type=script&lang=js"
import style0 from "./noAuth.vue?vue&type=style&index=0&id=6c1f40a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f40a6",
  null
  
)

export default component.exports